<template>
  <div>
    <div :class="['popup', {'popup-active': popupAnimation}]">
      <div class="popup-scroll">
        <div @click="switchPopup()" class="popup-back"/>

        <div class="popup--content">
          <div @click="switchPopup()" class="icon-exit"/>

          <div class="swiper-button-prev icon-arrow-left"/>

          <div class="popup--doc">
            <swiper ref="swip" :options="swiperOption">
              <swiper-slide v-for="(company, key) in slides" :key="key">
                <img :src="company.document.$src"/>
              </swiper-slide>
            </swiper>
          </div>

          <div class="swiper-button-next icon-arrow-right"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import filterCompanies from '@/helpers/filterCompanies';
import findObj from '@/helpers/findObj';

export default {
  mounted() {
    window.addEventListener('keyup', this.closeEsc);
    document.body.className = 'no-scroll';
    this.slides = this.fetchSliderCompanies();
    let key = findObj(this.slides, this.company, '$slug') + 1;
    if (key >= this.slides.length) {
      key = 0;
    }
    this.swiper().slideTo(key);
  },

  beforeDestroy() {
    window.removeEventListener('keyup', this.closeEsc);
    document.body.className = '';
  },

  data() {
    return {
      slides: [],
      slide: 2,
      swiperOption: {
        direction: 'horizontal',
        speed: 500,
        loop: true,
        effect: 'fade',
        paginationClickable: true,
        keyboardControl: true,
        grabCursor: false,
        slidesPerView: 1,
        spaceBetween: 0,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
    };
  },

  computed: mapGetters({
    popupAnimation: 'popupAnimation',
    companies: 'companies',
    company: 'company',
    popup: 'popup',
    theme: 'theme',
    lang: 'lang',
  }),

  methods: {
    swiper() {
      return this.$refs.swip.swiper;
    },

    fetchSliderCompanies() {
      return filterCompanies(this.companies, this.theme === 'dark', this.lang);
    },

    closeEsc(e) {
      if (e.keyCode === 27) {
        this.switchPopup();
      }
    },

    switchPopup() {
      this.$store.dispatch('popupState', !this.popup);
    },
  },
};
</script>

<style scoped>
.popup{
  background: rgba(2, 14, 52, 0.6);
  position: fixed;
  z-index: 999;
  bottom: 0;
  right: 0;
  left: 0;
  top: 0;

  &--content{
    text-align: center;
    position: relative;
    margin: 130px auto;
    max-width: 1000px;
    cursor: pointer;
    height: 80%;
  }

  &--doc{
    position: relative;
    max-width: 100%;
    margin: 0 auto 100px;
    text-align: center;

    img{
      border-radius: 2px;
      margin: 0 auto;
      max-width: 90%;

      @media (max-width: $mediaTiny) {
        max-width: 80%;
      }
    }
  }

  .swiper-slide{
    img{
      transition: all .3s ease-in-out;
      transform: scale(.8);
      visibility: hidden;
      user-select: none;
      opacity: 0;
    }
    &.swiper-slide-duplicate-active{
      opacity: 1 !important;
    }
    &.swiper-slide-duplicate-active,
    &.swiper-slide-active{
      opacity: 1;
      img{
        visibility: visible;
        transform: none;
        opacity: 1;
      }
    }
   }
   &-scroll{
    position: relative;
    overflow-y: scroll;
    height: 100vh;
    width: 100%;
  }

  .icon-arrow-right,
  .icon-arrow-left{
    transition: all .3s ease-in-out;
    position: fixed;
    top: 50%;

    &:before{
      font-size: 400%;

      @media (max-width: $mediaMob) {
        font-size: 240%;
      }
    }

    &:hover{
      opacity: .6;
    }
  }

  .icon-exit,
  .icon-arrow-right,
  .icon-arrow-left{
    background: none;
    cursor: pointer;
    outline: 0;
  }

  .icon-arrow-left{
    left: 5vw;

    @media (max-width: $mediaMob) {
      left: 20px;
    }
  }

  .icon-arrow-right{
    right: 5vw;

    @media (max-width: $mediaMob) {
      right: 20px;
    }
  }

  .icon-exit{
    transition: all .3s ease-in-out;
    position: fixed;
    z-index: 999;

    font-size: 300%;
    cursor: pointer;

    right: 3vw;
    top: 5vw;

    @media (max-width: $mediaMob) {
      font-size: 200%;
      right: 35px;
      top: 70px;
    }

    &:hover{
      opacity: .6;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PopupDocuments.vue